import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { IReduxStore } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { App } from '../../../shared/containers/App';
import { MicrofrontendContext } from '@cian/mf-react-legacy';
import { IBrowserMicrofrontend } from '@cian/mf-registry-legacy/browser';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
  microfrontend: IBrowserMicrofrontend;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context, microfrontend } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrateRoot(
    rootElement,
    <MicrofrontendContext.Provider value={microfrontend}>
      <App context={context} reduxStore={store} />
    </MicrofrontendContext.Provider>,
  );
}
